import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Homepage from './views/homepage'
import TermsConditions from './views/terms-conditions'
import NotFound from './views/not-found'
import SubPage from './views/sub-page'
import PpfKaplama from './views/ppf-kaplama'
import Projeler from './views/projeler'
import Galeri from './views/galeri'
import Blog from './views/blog'
import BlogDetail from './views/blog-detail'
import Hakkimizda from './views/hakkimizda'
import Iletisim from './views/iletisim'

const App = () => {
  return (
    <Router>
      <Switch>
        {/* Ana Sayfa */}
        <Route component={Homepage} exact path="/" />

        {/* Yasal & Şartlar (noindex) */}
        <Route component={TermsConditions} exact path="/terms-conditions" />

        {/* Araç Koruma Rotaları */}
        <Route
          exact
          path="/arac-koruma"
          render={(props) => (
            <SubPage
              {...props}
              title="Araç Koruma Çözümleri"
              seoTitle="Araç Koruma Çözümleri İstanbul | PPF & Seramik Kaplama | ATEŞ AUTO DETAILING"
              category="Araç Koruma"
              canonicalPath="/arac-koruma"
              description="Aracınızın değerini ve orijinal boyasını koruyan en üst düzey TPU PPF boya koruma filmi, 9H nano seramik ve hibrit araç koruma teknolojileri."
            />
          )}
        />
        <Route component={PpfKaplama} exact path="/ppf-kaplama" />
        <Route
          exact
          path="/arac-kaplama"
          render={(props) => (
            <SubPage
              {...props}
              title="Araç Kaplama & Renk Değişimi"
              seoTitle="İstanbul Araç Kaplama | Premium Renk Değişimi & Folyo | ATEŞ AUTO DETAILING"
              category="Araç Koruma"
              canonicalPath="/arac-kaplama"
              description="Geniş renk ve doku kartelasıyla birinci sınıf dökme cast folyo araç kaplama. Mat, saten ve parlak renk değişimi Beşiktaş Conrad atölyemizde."
            />
          )}
        />
        <Route
          exact
          path="/boya-koruma"
          render={(props) => (
            <SubPage
              {...props}
              title="Boya Koruma Uygulamaları"
              seoTitle="Araç Boya Koruma Uygulamaları İstanbul | ATEŞ AUTO DETAILING"
              category="Araç Koruma"
              canonicalPath="/boya-koruma"
              description="Güneşin zararlı UV ışınlarına, kimyasallara ve çevresel kirliliklere karşı boya yüzeyine derin parlaklık ve koruyucu katman kazandıran profesyonel uygulamalar."
            />
          )}
        />
        <Route
          exact
          path="/seramik-kaplama"
          render={(props) => (
            <SubPage
              {...props}
              title="Seramik Kaplama"
              seoTitle="Seramik Kaplama İstanbul | 9H Nano Boya Koruma | ATEŞ AUTO DETAILING"
              category="Araç Koruma"
              canonicalPath="/seramik-kaplama"
              description="9H sertliğinde nano seramik kaplama ile hidrofobik su iticilik, cam pürüzsüzlüğünde ayna parlaklığı ve uzun süreli vernik koruması."
            />
          )}
        />

        {/* Detailing Rotaları */}
        <Route
          exact
          path="/detayli-arac-temizligi"
          render={(props) => (
            <SubPage
              {...props}
              title="Detaylı Araç Temizliği"
              seoTitle="Detaylı Araç Temizliği İstanbul | İç & Dış Oto Detailing | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/detayli-arac-temizligi"
              description="Deri koltuk kondisyonlama, taban-tavan arındırma, ozon ve buharlı sterilizasyon ile stüdyo standartlarında profesyonel detaylı araç temizliği."
            />
          )}
        />
        <Route
          exact
          path="/boya-duzeltme"
          render={(props) => (
            <SubPage
              {...props}
              title="Boya Düzeltme"
              seoTitle="Boya Düzeltme & Çizik Giderme İstanbul | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/boya-duzeltme"
              description="Hologram, harelenme, derin kılcal çizikler ve portakal kabuğu kusurlarını vernik mikron ölçümü hassasiyetinde gideren çok aşamalı profesyonel işlem."
            />
          )}
        />
        <Route
          exact
          path="/polisaj"
          render={(props) => (
            <SubPage
              {...props}
              title="Polisaj & Çizik Giderme"
              seoTitle="Profesyonel Polisaj & Pasta Cila İstanbul | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/polisaj"
              description="Rotary ve dual-action polisaj makineleriyle uygulanan aşamalı pasta cila işlemiyle aracınızın boyasında kusursuz ayna yansıması ve derinlik."
            />
          )}
        />
        <Route
          exact
          path="/far-parlatma"
          render={(props) => (
            <SubPage
              {...props}
              title="Far Parlatma & Yenileme"
              seoTitle="Far Parlatma & Restorasyon İstanbul | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/far-parlatma"
              description="Sararmış, matlaşmış ve çizilmiş polikarbonat farların çok adımlı zımparalama ve kimyasal buharla ilk günkü berraklığına kavuşturulması ve UV koruma mühürlemesi."
            />
          )}
        />
        <Route
          exact
          path="/cam-filmi"
          render={(props) => (
            <SubPage
              {...props}
              title="Cam Filmi Uygulaması"
              seoTitle="Araç Cam Filmi Uygulaması İstanbul | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/cam-filmi"
              description="Yüksek ısı reddi, %99 UV blokajı ve kabin içi sürüş konforu sağlayan garantili karbon ve nano seramik araç cam filmi çözümleri."
            />
          )}
        />
        <Route
          exact
          path="/buharli-arac-temizligi"
          render={(props) => (
            <SubPage
              {...props}
              title="Buharlı Araç Temizliği"
              seoTitle="Buharlı Araç Temizliği İstanbul | Antibakteriyel Hijyen | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/buharli-arac-temizligi"
              description="Yüksek sıcaklıkta kuru buhar teknolojisiyle havalandırma kanalları, koltuk kumaşları ve erişilmesi güç iç mekan alanlarında %99.9 antibakteriyel hijyen."
            />
          )}
        />
        <Route
          exact
          path="/detayli-motor-temizligi"
          render={(props) => (
            <SubPage
              {...props}
              title="Detaylı Motor Temizliği & Koruma"
              seoTitle="Detaylı Motor Temizliği & Koruma İstanbul | ATEŞ AUTO DETAILING"
              category="Detailing"
              canonicalPath="/detayli-motor-temizligi"
              description="Hassas elektronik aksamlara zarar vermeden dielektrik güvenli temizleyicilerle yağ arındırma ve antistatik motor koruma kaplaması."
            />
          )}
        />

        {/* Kurumsal & Portfolyo Rotaları */}
        <Route component={Projeler} exact path="/projeler" />
        <Route component={Galeri} exact path="/galeri" />
        <Route component={BlogDetail} exact path="/blog/:slug" />
        <Route component={Blog} exact path="/blog" />
        <Route component={Hakkimizda} exact path="/hakkimizda" />
        <Route component={Iletisim} exact path="/iletisim" />

        {/* 404 Sayfası */}
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
